import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";

import { createTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

import { FaTimesCircle, FaBars, FaChromecast } from "react-icons/fa";
import { RiHome4Line, RiStackLine } from "react-icons/ri";
import { MdCastConnected } from "react-icons/md";
import { IoIosArrowBack } from "react-icons/io";

import { SendCastDetails2 } from "../../redux/v2/cast/actions";
import { programLevels } from "../../constants";
import { ScreenType } from "../../utils/breakpoints";

import { MdOutlineEmojiEvents } from "react-icons/md";
import CloseButton from "../../common/CloseButton";
import MobileNavV2 from "./MobileNavV2";
import Footer from "../Footer";
import useSVG from "../../hooks/useSVG";
import Reddot from "../../common/Reddot";
import CustomModalV2 from "../../common/CustomModalV2";

import Notifications from "../../pages/notifications";

import "./style.css";

function CustomMenu(props) {
    const platform = localStorage.getItem("indi-platform");
    const isUsingApp = platform && (platform === "ios-app" || platform === "android-app");

    const { native } = props.Cast;
    const { BellSVG } = useSVG();

    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 961,
                lg: 1200,
                xl: 1536,
            },
        },
    });
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const navRef = useRef(null);
    const outletRef = useRef(null); // set this to outlet ref

    const [device, setDevice] = useState(window.matchMedia("(max-width: 960px)").matches ? "mobile" : "desktop");
    useEffect(() => {
        setDevice(window.innerWidth <= 960 ? "mobile" : "desktop");
    }, [window.innerWidth]);

    useEffect(() => {
        // dispatch(getSearchListData());
    }, []);

    const clearLocalStorage = () => {
        const dev = localStorage.getItem("indi-device-type");
        const platform = localStorage.getItem("indi-platform");

        localStorage.clear();
        localStorage.setItem("indi-device-type", dev);
        localStorage.setItem("indi-platform", platform);
    };

    const [showSideDrawer, setShowSideDrawer] = useState(false);
    const [drawerView, setDrawerView] = useState("menu");
    const [showNotificationDrawer, setShowNotificationDrawer] = useState(false);

    const [links, setLinks] = useState([
        {
            path: "home",
            label: "Home",
            type: "both",
            icon: <RiHome4Line className={`footer-icon`} />,
            scope: ["home"],
        },

        {
            path: "programs",
            label: "Programs",
            type: "both",
            icon: <RiStackLine className={`footer-icon`} />,
            scope: ["program", "workout"],
        },

        {
            path: "challenges",
            label: "Challenges",
            type: "both",
            icon: <MdOutlineEmojiEvents className={`footer-icon`} />,
            scope: ["challenges"],
        },
    ]);

    const handleMenuDrawer = () => {
        setDrawerView("menu");
        setShowSideDrawer(!showSideDrawer);
    };

    const handleNotificationDrawer = () => {
        setDrawerView("notification");
        setShowSideDrawer(!showSideDrawer);
    };

    const SetSubmenuStatus = (ind, bool) => {
        var tempLinks = [...links];
        tempLinks[ind] = {
            ...tempLinks[ind],
            openSubMenu: !tempLinks[ind].openSubMenu,
        };
        setLinks(tempLinks);
    };

    const [showDesktopMenuSideDrawer, setShowDesktopMenuSideDrawer] = useState(false);
    const [showDesktopNotificationSideDrawer, setShowDesktopNotificationSideDrawer] = useState(false);

    const SearchComponent = ({ id }) => {
        return <div id={id} className="search-component"></div>;
    };

    const { pendingWorkout } = props.Workout;
    const { programs } = props.Program;

    let prog = programs.filter((p) => p.id == pendingWorkout?.program_id);

    const pageNames = {
        "/programs": "PROGRAMS",
        "/program-detail": "PROGRAMS",
        "/workout": `${prog[0]?.title || ""}` + (pendingWorkout?.program_detail_id ? ` - ${programLevels[pendingWorkout?.program_detail_id]}` : ""),
        "/favorites": "Favorites",
        "/exercises": "Exercises",
        "/exercises/individual-exercise": "Exercises",
        "/fitness": "Fitness",
        "/account": "My Account",
        "/cancel-subscription": "My Account",
        "/indi-support": "Indi Support",
        "/company-challenge": "Company Challenge",
        "/plus-one": "Company +1",
        "/patient-invite": "Patient Discharge",
        "/challenges": "Challenges",
        "/settings/notification": "Notifications",
    };

    const screenSize = ScreenType(useMediaQuery);

    return (
        <div id="app-user-layout">
            {showSideDrawer ? (
                <div
                    style={{
                        height: "100%",
                        width: "100%",
                        position: "absolute",
                        zIndex: 4,
                    }}
                    onClick={handleMenuDrawer}
                ></div>
            ) : (
                ""
            )}

            <header>
                <nav className="navbar" ref={navRef}>
                    {location.pathname != "/" && location.pathname != "/home" && screenSize != "xl" ? (
                        <div
                            id="navbar-back-button"
                            onClick={() => {
                                try {
                                    if (window?.navigation?.canGoBack || window?.history?.state?.idx != 0) {
                                        navigate(-1);
                                    } else {
                                        navigate("/");
                                    }
                                } catch (err) {
                                }
                            }}
                        >
                            {/* <Back /> */}
                            <IoIosArrowBack />
                            <h6>{pageNames[location.pathname]?.toLowerCase()}</h6>
                        </div>
                    ) : (
                        <div id="navbar-back-button" style={{ paddingLeft: "10px" }}>
                            <Link className="navbar-brand" to="/home">
                                <img src="/assets/images/logo.png" className="logo" />
                            </Link>
                        </div>
                    )}

                    {matchesSM || matchesMD ? (
                        <div className="menu-icon-v2">
                            {isUsingApp &&
                                (native.isPlayingCast ? (
                                    <MdCastConnected
                                        className="cast-header-icon"
                                        onClick={() => {
                                            props.SendCastDetails2();
                                        }}
                                    />
                                ) : (
                                    <FaChromecast
                                        className="cast-header-icon"
                                        onClick={() => {
                                            props.SendCastDetails2(native.video ? true : false);
                                        }}
                                    />
                                ))}

                            <div
                                id="bell-svg-wrapper"
                                onClick={() => {
                                    handleNotificationDrawer();
                                }}
                            >
                                <Reddot clicked={drawerView == "notification" && showSideDrawer} />
                                {BellSVG}
                            </div>

                            <FaBars className="menu-bar-icon" onClick={handleMenuDrawer} />
                        </div>
                    ) : (
                        <div className="menu-icon">
                            <SearchComponent id="mobile-search-component" />
                            <FaBars className="menu-bar-icon" onClick={handleMenuDrawer} />
                        </div>
                    )}

                    {
                        // Menu Drawer
                        matchesSM || matchesMD ? (
                            <ul className={showSideDrawer ? "nav-menu active mobile-v2" : "nav-menu"}>
                                <div className="nav-menu-mobile-v2">
                                    <CloseButton
                                        onClick={() => {
                                            setShowSideDrawer(!showSideDrawer);
                                        }}
                                        className="close-button"
                                    />
                                </div>

                                <div style={drawerView != "menu" ? { display: "none" } : {}}>
                                    {" "}
                                    {/*Menu Warapper*/}
                                    <MobileNavV2 onClickCloseButton={handleMenuDrawer} />
                                </div>

                                <div style={drawerView != "notification" ? { display: "none" } : {}}>
                                    {" "}
                                    {/*Notification Warapper*/}
                                    <Notifications onClickCloseButton={handleMenuDrawer} />
                                </div>
                            </ul>
                        ) : (
                            <>
                                <ul className={showSideDrawer ? "nav-menu active" : "nav-menu"}>
                                    {links.map((link, i) => {
                                        let isActiveLink = false;

                                        if (location.pathname != "/") {
                                            for (let x = 0; x < link.scope.length; x++) {
                                                if (location.pathname.includes(link.scope[x])) {
                                                    isActiveLink = true;
                                                    break;
                                                }
                                            }
                                        } else {
                                            isActiveLink = location.pathname == "/" && link.path == "home";
                                        }

                                        return link.type == device || link.type == "both" ? (
                                            <li className="nav-item" key={"menu-link-" + i}>
                                                <Link
                                                    to={"/" + link.path}
                                                    className={"nav-links" + (link.sub ? " w-sub-nav" : "") + (isActiveLink ? " active-link" : "")}
                                                    onClick={(e) => {
                                                        if (link.hasOwnProperty("callback")) {
                                                            link.callback();
                                                        }

                                                        if (!link.sub) {
                                                            handleMenuDrawer();

                                                            setLinks(
                                                                links.map((l, i3) => {
                                                                    return {
                                                                        ...l,
                                                                        openSubMenu: false,
                                                                    };
                                                                })
                                                            );
                                                        } else {
                                                            e.preventDefault();

                                                            SetSubmenuStatus(i);
                                                        }
                                                    }}
                                                >
                                                    {link.icon}
                                                    <h6>{link.label}</h6>
                                                </Link>
                                            </li>
                                        ) : (
                                            ""
                                        );
                                    })}

                                    <li className="nav-item" key="menu-link-menu--1">
                                        <div
                                            id="bell-svg-wrapper"
                                            onClick={() => {
                                                setShowDesktopMenuSideDrawer(false);
                                                setShowDesktopNotificationSideDrawer(!showDesktopNotificationSideDrawer);
                                            }}
                                        >
                                            <Reddot clicked={showDesktopNotificationSideDrawer} />
                                            {BellSVG}
                                        </div>
                                    </li>

                                    <li className="nav-item" key="menu-link-menu--2">
                                        <FaBars
                                            className="menu-bar-icon mbi-web clickable"
                                            onClick={() => {
                                                setShowDesktopNotificationSideDrawer(false);
                                                setShowDesktopMenuSideDrawer(!showDesktopMenuSideDrawer);
                                            }}
                                        />
                                    </li>
                                </ul>
                            </>
                        )
                    }
                </nav>

                <div id="desktop-menu-drawer-wrapper" className={showDesktopMenuSideDrawer ? "show" : ""}>
                    <div id="desktop-menu-drawer">
                        <div className="dmd-header">
                            <FaTimesCircle
                                onClick={() => {
                                    setShowDesktopMenuSideDrawer(false);
                                }}
                            />
                        </div>
                        <div className="dmd-menus">
                            <MobileNavV2
                                onClickCloseButton={() => {
                                    setShowDesktopMenuSideDrawer(false);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <div id="desktop-menu-drawer-wrapper" className={showDesktopNotificationSideDrawer ? "show" : ""}>
                    <div id="desktop-menu-drawer">
                        <Notifications
                            onClickCloseButton={() => {
                                setShowDesktopMenuSideDrawer(false);
                            }}
                        />
                    </div>
                </div>
            </header>

            <div className="outlet-v2" ref={outletRef}>
                <Outlet />
            </div>
            <footer className="mobile-section desktop-display-none mobile-footer">
                <Footer />
            </footer>
            <CustomModalV2 />
        </div>
    );
}

const mapStateToProps = (state) => ({
    Cast: state.Cast,
    Workout: state.Workout,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    SendCastDetails2,
})(CustomMenu);
